import React from "react";
import { CustomHeading, HeadingContainer, Subtitle, TitleContainer } from "@pages/style";
import { EmptyState } from "@components/EmptyState";
import { EmptyStatePayments } from "@components/svgs";

const PaymentsPage = () => {
  return (
    <div>
      <HeadingContainer>
        <TitleContainer>
          <CustomHeading noMargin>Pagamentos</CustomHeading>
          <Subtitle color="gray" size="lg" noMargin>
            Encontre faturas e honorários e os documentos de pagamento relacionados a eles.
          </Subtitle>
        </TitleContainer>
      </HeadingContainer>

      <EmptyState icon={<EmptyStatePayments />} title="Nenhum registro de pagamento disponível">
        Quando o advogado adicionar registros de pagamentos, eles aparecerão aqui.
      </EmptyState>
    </div>
  );
};

export default PaymentsPage;
